import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, FormlyService, GridService, ModalService } from '../../../../tms-shared';
import { AddressAddresseeService } from '../../../services/edit-create/address/address-addressee.service';
import { AddressAddressee, ProductCustomerDetails } from '../../../models';
import { AddressCreateAddresseesModalComponent } from '../address-create-addressees-modal/address-create-addressees-modal.component';

@Component({
  selector: 'app-address-addressees',
  templateUrl: './address-addressees.component.html',
  styleUrl: './address-addressees.component.scss',
})
export class AddressAddresseesComponent extends BaseComponent implements OnInit {
  model$: Observable<AddressAddressee[]>;

  @Input() addressId: string;

  fields: FormlyFieldConfig[];

  columnDefs: ColDef[] = [
    this.gridService.text('addressee', $localize`Addressee`),
    this.gridService.text('addressSingleLine', $localize`Address`),
  ];

  constructor(
    private addressAddresseeService: AddressAddresseeService,
    private gridService: GridService,
    private formlyService: FormlyService,
    private modalService: ModalService,
    private route: ActivatedRoute,
  ) {
    super();
  }

  ngOnInit() {
    if (!this.addressId) {
      this.addressId = this.route.snapshot.paramMap.get('id');
    }
    this.getModel();
  }

  getModel() {
    this.model$ = this.addressAddresseeService.getForAddress(this.addressId);
  }

  create() {
    this.openAddressees(undefined, this.addressId);
  }

  edit(model: ProductCustomerDetails) {
    this.openAddressees(model.id);
  }

  delete(model: AddressAddressee) {
    this.addressAddresseeService
      .delete(model.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.getModel());
  }

  private openAddressees(id: string, addressId?: string) {
    const { modal, component } = this.modalService.openMedium<AddressCreateAddresseesModalComponent>(
      AddressCreateAddresseesModalComponent,
    );
    component.id = id;
    component.addressId = addressId;
    modal.result.then(
      () => this.getModel(),
      () => {},
    );
  }
}
